import React from 'react'
import { format } from 'date-fns'
import TextField from '@mui/material/TextField'
import FormControl from '@mui/material/FormControl'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import Box from '@mui/material/Box'
import Paper from "@mui/material/Paper"
import Button from '@mui/material/Button'
import CircularProgress from "@mui/material/CircularProgress"
import {Context as AppContext} from '../../contexts/App'
import {Context as NotificationsContext} from '../../contexts/Notifications'
import {Context as SalesChannelsContext} from '../../contexts/SalesChannels'
import config from '../../config.json'
import DropZone from '../../components/Dropzone'

const failedDownloadSnack = 'ProductPublicies-failedDownloadSnack'
const ProductPublicies = () => {
  const { vendor } = React.useContext(AppContext)
  const { createBulk } = React.useContext(SalesChannelsContext).productPublicities
  const [disabled, setDisabled] = React.useState(false)
  const [date, setDate] = React.useState(null)
  const [filesAmazon, setAmazonFiles] = React.useState([])
	const [filesMercado, setMercadoFiles] = React.useState([])
	const [clear, setClear] = React.useState(false)
	React.useEffect(() => {
		setClear(true)
	}, [vendor])

	React.useEffect(() => {
		clear && setClear(false)
	}, [clear])
  const flag = filesAmazon.length > 0 || filesMercado.length > 0
    
  const {createSnack, openSnack, deleteSnack} = React.useContext(NotificationsContext)

	React.useEffect(() => {
		createSnack(failedDownloadSnack, {message: "Falló la generación de costos de publicidad de productos"})
		return () => deleteSnack(failedDownloadSnack)
	}, [])

	const onError = () => {
		setDisabled(false)
		openSnack(failedDownloadSnack)
	}

  const submitFile = e => {
    e.stopPropagation()
    setDisabled(true)
    const data = new FormData()
    const costs = vendor === 'amazon'? filesAmazon[0] : filesMercado[0]
    data.append("productPublicities", costs)
    data.append("vendor", vendor)
    data.append("date", date)
    createBulk(data, (download) => {
      if(download){
        console.log("downloading publicityFile from source: ", config.api_url+download)
        window.open(config.api_url+download, "_blank")
      }
      setDisabled(false)
      setClear(true)
    }, onError)
  }
  
  return (
    <div style={{
      display: 'flex',
      justifyContent: "center",
      margin: 'auto',
      width: 400,
      flexWrap: 'wrap',
    }}>
      <div style={{ width: '100%', float: 'left' }}>
        <h3>Subir costos de publicidad de producto</h3> <br />
      </div>
      {vendor && 
        <Paper sx={{ cursor: flag?'auto':'pointer', position: 'relative', minWidth:"200px", minHeight: '200px', display: "flex", justifyContent: "space-around", alignItems: "center", flexDirection: "column",padding: "15px"}}>
          <Box>
            <FormControl sx={{ m: 1, width: '25ch' }}>
              <DatePicker
                views={['year', 'month']}
                label="Fecha"
                name="date"
                onChange={(m) => console.log({m}, format(m, 'yyyy-MM')) || setDate(format(m, 'yyyy-MM'))}
                value={date?date+"-1":date}
                inputFormat="yyyy-MM"
                defaultValue={null}
                renderInput={(params) => <TextField {...params} inputProps={{...(params.inputProps || {}), readOnly: true}} />}
                
              />
            </FormControl>
          </Box>
          {vendor &&
            <>
            <Box sx={{display:vendor === 'amazon'?'block':'none'}}>
              <DropZone accept=".csv" files={filesAmazon} setFiles={setAmazonFiles} clear={clear}/>
            </Box>
            <Box sx={{display:vendor === 'mercado'?'block':'none'}}>
              <DropZone accept=".xlsx" files={filesMercado} setFiles={setMercadoFiles} clear={clear}/>
            </Box>
            </>
          }
          <Button disabled={!flag || !date || disabled} onClick={submitFile} variant="contained" color="primary">
            {disabled?<CircularProgress size={27}/>:'Añadir costos de publicidad'}
          </Button>
        </Paper>
      }  
    </div>
  )
}

export default ProductPublicies